module.exports = [{"type":"title","text":"2024-12-06"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續U本位：查詢全部掛單API /openApi/swap/v2/trade/openOrders 支援根據訂單類型查詢"},{"type":"html","text":"永續U本位：撤銷全部掛單API /openApi/swap/v2/trade/allOpenOrders 支援根據訂單類型撤銷"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2024-12-06.json
// module id = JseK
// module chunks = 3